import { IntlShape, useIntl } from "react-intl";
import { FunctionComponent, memo, PropsWithChildren } from "react";

/**
 * This implement to hold an instance of Intl so that can be used outside react life cycle (eg. redux actions)
 */
export let localeInst: IntlShape;
const LocaleProviderComponent: FunctionComponent<PropsWithChildren<any>> = ({ children }) => {
    localeInst = useIntl();
    return children || null;
};

export default memo(LocaleProviderComponent);
